module.exports = "../content/a90c0c9d0f7cf6706c2aef0dc8677837.woff2";